import { WeekdaysBackendEnum } from '../types/availability-interface'

export function AvailabilitySlotsSkeleton() {
  return (
    <div className="flex flex-col">
      {Object.values(WeekdaysBackendEnum).map(weekday => (
        <div
          key={weekday}
          className="border-text-secondary/50 [&>div]:h-7 grid grid-cols-3 gap-4 border-t py-5 md:grid-cols-4"
        >
          <div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div>
          <div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div>
          <div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div>
          <div className="bg-skeleton-primary hidden animate-pulse rounded-sm text-transparent md:block">
            .
          </div>
        </div>
      ))}
    </div>
  )
}
